// src/components/AuctionEnrollmentSection.jsx

import { Component } from 'react';
import '../../../../../../styles/components/auction-enrollment.scss';

import { CircleArrowDown, BanknoteArrowDown } from 'lucide-react';
import CashFlowTable from '../CashFlowTable';
import CashFlowStatCard from '../CashFlowStatCard';
import Donut from '../Donut';
import { COLORS } from '../../constants/colors';

class AuctionEnrollmentSection extends Component {
  render() {
    const { data } = this.props;
    const donutSegments = [
      { value: data?.enrollment?.online?.amount || 0, color: COLORS.teal, label: 'Online' },
      { value: data?.enrollment?.offline?.amount || 0, color: COLORS.tealMid, label: 'Offline' },
    ];

    return (
      <section className="auction-enrollment">
        {/* Cards */}
        <div className="ae-grid">
          {/* <CashFlowStatCard
            icon={<ShieldUser size={24} strokeWidth={2} />}
            title="ENROLLED BIDDERS (STRATEGY)"
            value={data?.enrollment?.stratergy?.count || 0}
            subtitle={'Strategic enrollment count'}
            iconClass="blue"
            valueClass="blue-text"
          /> */}
          <CashFlowStatCard
            icon={<BanknoteArrowDown size={24} strokeWidth={2} />}
            title="ENROLLMENT AMOUNT RECEIVED"
            value={data?.enrollment?.sub_total?.amount || 0}
            subtitle={`${data?.enrollment?.sub_total?.count || 0} Enrollments`}
            iconClass="green"
            valueClass="green-text"
            color="#32a852"
          />
        </div>

        {/* Cash Flow IN  */}

        <div className="cashflow in">
          {/* Header */}
          <div className="cf-header">
            <div className="cf-header__left">
              <div className="cf-main-icon green">
                <CircleArrowDown size={20} strokeWidth={1.8} />
              </div>

              <div>
                <h2 className="cf-title">CASH FLOW IN</h2>

                <p className="cf-subtitle">TOTAL ENROLLMENT RECEIVED</p>
              </div>
            </div>
          </div>
          <div className="cf-details">
            <CashFlowTable
              search={this.props.search}
              data={[
                {
                  id: 1,
                  method: 'online',
                  icon: 'globe',
                  count: data?.enrollment?.online?.count || 0,
                  amount: data?.enrollment?.online?.amount || 0,
                  percentage: 77,
                  color: '#10b981',
                },
                {
                  id: 2,
                  method: 'offline',
                  icon: 'creditCard',
                  count: data?.enrollment?.offline?.count || 0,
                  amount: data?.enrollment?.offline?.amount || 0,
                  percentage: 18,
                  color: '#3b82f6',
                },
                // {
                //   id: 2,
                //   method: 'Wallet Transaction',
                //   icon: 'wallet',
                //   count: 5,
                //   amount: 2500,
                //   percentage: 18,
                //   color: '#fbbf24',
                // },
              ]}
              totalCount={data?.enrollment?.sub_total?.count || 0}
              totalAmount={data?.enrollment?.sub_total?.amount || 0}
            />
            <Donut segments={donutSegments} />
          </div>
        </div>
      </section>
    );
  }
}

export default AuctionEnrollmentSection;
